import { CpuChipIcon } from "@heroicons/react/24/outline"
import { Route, Routes, } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import RouteKeys from "constants/route-keys"
import PersonalizedSimulation from "./PersonalizedSimulation"


const _routes: RouteElement[] = [
    {
        // use empty string so the list renders at /personalized-simulation
        route: '',
        title: 'Personalized Simulation',
        key: RouteKeys.PERSONALIZED_SIMULATION,
        component: PersonalizedSimulation,
        icon: CpuChipIcon,
        display: true
    }
]
const PersonalizedSimulationManagement = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {
                        _routes.map((route, index) => (
                            <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default PersonalizedSimulationManagement